"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class AddedLmIntent
 */
// tslint:disable-next-line:max-classes-per-file

var AddedLmIntent =
/** @class */
function () {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param modelImpl - The model.
   * @param intentName - The intent name.
   */
  function AddedLmIntent(modelImpl, intentName) {
    this.modelImpl = modelImpl;
    this.intentName = intentName;
  }

  return AddedLmIntent;
}();

exports.AddedLmIntent = AddedLmIntent;